import { z } from 'zod';

export const contextFormSchema = z.object({
  name: z.string()
    .min(1, 'Nome do contexto é obrigatório')
    .min(2, 'Nome do contexto deve ter pelo menos 2 caracteres')
    .max(100, 'Nome do contexto deve ter no máximo 100 caracteres'),
  
  contextId: z.string()
    .min(1, 'ID do contexto é obrigatório')
    .min(2, 'ID do contexto deve ter pelo menos 2 caracteres')
    .max(50, 'ID do contexto deve ter no máximo 50 caracteres'),
  
  type_id: z.string()
    .min(1, 'Tipo de contexto é obrigatório'),
  
  associatedTopic: z.array(z.string())
    .min(1, 'Selecione pelo menos um tópico associado'),
  
  associatedTerritory: z.array(z.string())
    .min(1, 'Selecione pelo menos um território associado'),
  
  fixedKeywords: z.array(z.string())
    .min(1, 'Digite pelo menos uma palavra-chave fixa'),
  
  dynamicKeywords: z.array(z.string())
    .min(1, 'Digite pelo menos uma palavra-chave dinâmica'),
  
  startDate: z.date({
    required_error: 'Data de início é obrigatória', 
  }),
  
  endDate: z.date({
    required_error: 'Data de fim é obrigatória',
  }),
  
  frequency: z.string()
    .min(1, 'Frequência é obrigatória'),
  
  dataOrigin: z.string()
    .min(1, 'Origem do dado é obrigatória'),
  
  region: z.string()
    .min(1, 'Região é obrigatória')
    .max(100, 'Região deve ter no máximo 100 caracteres'),
  
  predominantLanguage: z.string()
    .min(1, 'Idioma predominante é obrigatório'),
  
  usualHashtags: z.array(z.string())
    .min(1, 'Digite pelo menos uma hashtag usual'),
  
  mainWebsite: z.string()
    .url('Digite uma URL válida')
    .optional()
    .or(z.literal('')),
  
  description: z.string()
    .min(1, 'Descrição é obrigatória')
    .min(10, 'Descrição deve ter pelo menos 10 caracteres')
    .max(500, 'Descrição deve ter no máximo 500 caracteres'),
  
  interestSectors: z.string()
    .min(1, 'Selecione um setor de interesse'),
});

export type ContextFormData = z.infer<typeof contextFormSchema>;
